const state = {
    role_list: [],
    roles_selected_left: [],
    roles_selected_right: []
  }
  
  export default state
  


//////////////////
// WEBPACK FOOTER
// ./state/role/role.state.js
// module id = null
// module chunks = 